import clsx from "clsx";

import { Loading } from "components";

import { ButtonProps } from "./types";

import "./styles.scss";

function getLoadingIcon(hierarchy: string) {
	switch (hierarchy) {
		case "primary":
			return "neutral";
		case "secondary":
		case "ghost":
		default:
			return "primary";
	}
}

export default function Button({
	kind = "default",
	hierarchy = "primary",
	type = "button",
	disabled = false,
	size = "medium",
	onClick,
	leading,
	trailing,
	children,
	className,
	isLoading,
	childrenWrapperClassName,
	...args
}: Readonly<ButtonProps>) {
	return (
		<button
			type={type}
			className={clsx(`button-component ${className || ""}`, {
				"button-default": kind === "default",
				"button-link": kind === "link",
				"button-icon": kind === "icon",
				"button-chip": kind === "chip",
				"button-primary": hierarchy === "primary",
				"button-secondary": hierarchy === "secondary",
				"button-ghost": hierarchy === "ghost",
				"button-is-loading": isLoading === true,
				"button-small": size === "small",
				"button-medium": size === "medium",
				"button-large": size === "large",
				"button-disabled": disabled
			})}
			disabled={disabled || isLoading}
			onClick={onClick}
			{...args}
		>
			<div className={clsx("button-children", childrenWrapperClassName)}>
				{leading && <span className="first-icon">{leading}</span>}
				{children}
				{trailing && <span className="last-icon">{trailing}</span>}
			</div>
			{isLoading && <Loading type={getLoadingIcon(hierarchy)} />}
		</button>
	);
}
